import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddOutcomeToSceneModalPage } from './add-outcome-to-scene-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddOutcomeToSceneModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddOutcomeToSceneModalPage]
})
export class AddOutcomeToSceneModalPageModule {}
